export const Users = [
  {
    id:1,
    profilePicture: "people/duck burn.jpg",
    username: "These People",
  },
  {
    id:2,
    profilePicture: "people/father.jpg",
    username: "are dummy",
  },
  {
    id:3,
    profilePicture: "people/problem.jpg",
    username: "data People",
  },
  {
    id:4,
    profilePicture: "people/rainbow.jpg",
    username: "Please dont mind",
  },
  {
    id:5,
    profilePicture: "people/trollfather.jpg",
    username: "Them, Just filling",
  },
  {
    id:6,
    profilePicture: "people/two-face.jpg",
    username: "empty space",
  }
  
];

export const Posts = [
  {
    id: 1,
    desc: "Love My dog in farm",
    photo: "post/dogfarm.jpeg",
    date: "5 mins ago",
    userId: 1,
    like: 32,
    comment: 9,
  },
  {
    id: 2,
    desc:"My dog",
    photo: "post/petting_dog.jpeg",
    date: "15 mins ago",
    userId: 2,
    like: 2,
    comment: 1,
  },
  {
    id: 3,
    desc: "Every moment is a fresh beginning.",
    photo: "post/universe.jpeg",
    date: "1 hour ago",
    userId: 3,
    like: 61,
    comment: 2,
  },
  {
    id: 4,
    desc:"Love to read",
    photo: "post/reading-book.jpeg",
    date: "4 hours ago",
    userId: 4,
    like: 7,
    comment: 3,
  },
  {
    id: 5,
    desc:"My book shelf",
    photo: "post/book.jpeg",
    date: "5 hours ago",
    userId: 5,
    like: 23,
    comment: 5,
  },
  {
    id: 6,
    desc:"My cat",
    photo: "post/Cat.jpeg",
    date: "1 day ago",
    userId: 6,
    like: 44,
    comment: 6,
  }
];